const MATTER_EDITOR_BASE_PATH = "matter-editor";
const MATTER_TEMPLATE_EDITOR_BASE_PATH = "administrator/library-content/matter-templates";

export const Path = {
  MATTER_EDITOR_BASE_PATH,
  MATTER_TEMPLATE_EDITOR_BASE_PATH,

  toMatterEditor: (matterId: number) => `/${MATTER_EDITOR_BASE_PATH}/${matterId}`,
  toMatterTemplateEditor: (matterTemplateId: number) =>
    `/${MATTER_TEMPLATE_EDITOR_BASE_PATH}/${matterTemplateId}`,
};
